import Axios from "axios";

export function GetEstado() {
  return Axios.get("https://servicodados.ibge.gov.br/api/v1/localidades/estados");
}
export function GetCidade(id) {
  return Axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${id}/distritos`);
}
